<template>
  <div id="vr">
    <div class="rows">
      <div class="row pb-5">
        <div class="dropdown" v-bind:class="{ 'is-active': activeSurvey }">
          <div class="dropdown-trigger">
            <button
              class="button"
              aria-haspopup="true"
              aria-controls="dropdown-menu"
              v-on:click="activeSurvey = !activeSurvey"
            >
              <span>Locatie: {{ selectedSurvey }}</span>
              <span class="icon is-small">
                <i
                  v-if="activeSurvey"
                  class="fas fa-angle-up"
                  aria-hidden="true"
                ></i>
                <i v-else class="fas fa-angle-down" aria-hidden="true"></i>
              </span>
            </button>
          </div>
          <div class="dropdown-menu" id="dropdown-menu" role="menu">
            <div class="dropdown-content">
              <a
                v-for="(survey, index) in Object.keys(surveys)"
                :key="survey"
                v-bind:class="{ 'is-active': selectedSurvey === survey }"
                v-on:click="selectedSurvey = survey"
                class="dropdown-item"
              >
                {{ survey }}
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="row columns">
        <div class="column" ref="container">
          <!--          <pano-->
          <!--            title="10-06-2019"-->
          <!--            width="380"-->
          <!--            height="250"-->
          <!--            :bundle="panoImage"-->
          <!--            format="jpg">-->
          <!--          </pano>-->
        </div>
      </div>
      <div class="row columns">
        <div
          v-for="(image, index) in surveys[selectedSurvey].images"
          :key="index"
          class="column is-one-quarter"
        >
          <img :src="image" v-on:click="onImageClick(index)" />
        </div>
      </div>
    </div>

    <div class="dropdown" v-bind:class="{ 'is-active': activeQuestion }">
      <div class="dropdown-trigger">
        <button
          class="button"
          aria-haspopup="true"
          aria-controls="dropdown-menu"
          v-on:click="activeQuestion = !activeQuestion"
        >
          <span>{{
            surveys[selectedSurvey].questions[selectedQuestion].name
          }}</span>
          <span class="icon is-small">
            <i
              v-if="activeQuestion"
              class="fas fa-angle-up"
              aria-hidden="true"
            ></i>
            <i v-else class="fas fa-angle-down" aria-hidden="true"></i>
          </span>
        </button>
      </div>
      <div class="dropdown-menu" id="dropdown-menu" role="menu">
        <div class="dropdown-content">
          <a
            v-for="(questions, index) in surveys[selectedSurvey].questions"
            :key="questions.name"
            v-bind:class="{ 'is-active': selectedQuestion === index }"
            v-on:click="selectedQuestion = index"
            class="dropdown-item"
          >
            {{ questions.name }}
          </a>
        </div>
      </div>
    </div>

    <img width="100%" :src="tagCloud" />
  </div>
</template>

<script>
export default {
  name: "VR",
  components: {},
  props: {
    entityId: String,
    highlightDate: Object,
    parkingChartData: Object,
    chartMaxYAxis: Number
  },
  computed: {
    panoImage() {
      let pi = this.surveys[this.selectedSurvey].panoImages[
        this.selectImageIndex
      ];
      // eslint-disable-next-line
      console.log(pi);
      return pi;
    },
    currentDate() {
      return this.surveys[this.selectedSurvey].date;
    },
    tagCloud() {
      return this.surveys[this.selectedSurvey].questions[this.selectedQuestion]
        .tagcloud;
    }
  },
  data() {
    return {
      selectImageIndex: 0,
      activeSurvey: false,
      activeQuestion: false,
      selectedSurvey: "Kermis",
      selectedQuestion: 0,
      surveys: {
        Winter: {
          date: "25-03-2019",
          questions: [
            {
              name: "Hoe ervaart u deze plek?",
              tagcloud: "/vr/deventer/tagclouds/winter-ervaart.jpeg"
            },
            {
              name: "Wat vindt u aansprekend aan deze plek?",
              tagcloud: "/vr/deventer/tagclouds/winter-aantrekkelijk.jpeg"
            },
            {
              name: "Wat vindt u niet aansprekend aan deze plek?",
              tagcloud: "/vr/deventer/tagclouds/winter-nietaantrekkelijk.jpeg"
            }
          ],
          images: [
            "/vr/deventer/20190325-Grote-Kerkhof-00010.jpg",
            "/vr/deventer/20190325-Grote-Kerkhof-00011.jpg"
          ],
          panoImages: [
            "/vr/deventer/20190325-Grote-Kerkhof-00010/",
            "/vr/deventer/20190325-Grote-Kerkhof-00011/"
          ]
        },
        Zomer: {
          date: "17-09-2019",
          questions: [
            {
              name: "Hoe ervaart u deze plek?",
              tagcloud: "/vr/deventer/tagclouds/zomer-ervaart.jpeg"
            },
            {
              name: "Wat vindt u aansprekend aan deze plek?",
              tagcloud: "/vr/deventer/tagclouds/zomer-aantrekkelijk.jpeg"
            },
            {
              name: "Wat vindt u niet aansprekend aan deze plek?",
              tagcloud: "/vr/deventer/tagclouds/zomer-nietaantrekkelijk.jpeg"
            }
          ],
          images: [
            "/vr/deventer/20190917-Grote-Kerkhof-00006.jpg",
            "/vr/deventer/20190917-Grote-Kerkhof-00008.jpg"
          ],
          panoImages: [
            "/vr/deventer/20190917-Grote-Kerkhof-00006/",
            "/vr/deventer/20190917-Grote-Kerkhof-00008/"
          ]
        },
        Kermis: {
          date: "10-06-2019",
          questions: [
            {
              name: "Hoe ervaart u deze plek",
              tagcloud: "/vr/deventer/tagclouds/kermis-ervaart.jpeg"
            },
            {
              name: "Wat vindt u aansprekend aan deze plek",
              tagcloud: "/vr/deventer/tagclouds/kermis-aantrekkelijk.jpeg"
            },
            {
              name: "Wat vindt u niet aansprekend aan deze plek",
              tagcloud: "/vr/deventer/tagclouds/kermis-nietaantrekkelijk.jpeg"
            }
          ],
          images: [
            "/vr/deventer/20190610-Grote-Kerkhof-00002.jpg",
            "/vr/deventer/20190610-Grote-Kerkhof-00004.jpg"
          ],
          panoImages: [
            "/vr/deventer/20190610-Grote-Kerkhof-00002/",
            "/vr/deventer/20190610-Grote-Kerkhof-00004/"
          ]
        }
      }
    };
  },
  watch: {
    selectedSurvey() {
      this.activeSurvey = false;
      this.$children[0].$destroy();
      // var ComponentClass = Vue.extend(Pano)
      // var vm = new ComponentClass({
      //     propsData: {
      //       title: this.currentDate,
      //       width: "380",
      //       height:"250",
      //       bundle: this.panoImage,
      //       format:"jpg"
      //     }
      //   })
      //   // vm.$mount('.vue-pano')
      //   this.$children.push(vm)
    },
    selectedQuestion() {
      this.activeQuestion = false;
    }
  },
  methods: {
    onImageClick(index) {
      this.selectImageIndex = index;
      this.$children[0].$destroy();
      // var ComponentClass = Vue.extend(Pano)
      //
      // var vm = new ComponentClass({
      //   propsData: {
      //     title: this.currentDate,
      //     width: "380",
      //     height:"250",
      //     bundle: this.panoImage,
      //     format:"jpg"
      //   }
      // })
      // // vm.$mount('.vue-pano')
      // this.$children.push(vm)
    }
  }
};
</script>

<style>
.row img {
  height: 60px;
  border: solid 1px grey;
}

.pb-5 {
  padding-bottom: 10px;
}
</style>
